/**
* Accordion panels, used for FAQs etc
*/

import $ from 'jquery';

// Cached elements
const $el = {
	allPanels: $('.js-accordion > dd'),
	accordionButton: $('.js-accordion > dt')
};

// Module events
export default function init() {
	bindEvents();
}

// User interactions go here
function bindEvents() {
	$el.accordionButton.on('click', doAccordion);
}

function doAccordion() {
	
	const $this = $(this);
	const $accordionContent = $this.next();
	
	// Add/remove open classes
	$el.accordionButton.removeClass('is-active');
	$this.addClass('is-active');
	
	if ($accordionContent.is(':visible')) {
		$accordionContent.slideUp({
			easing: 'easeInOutQuart'
		});
		$this.removeClass('is-active');
	} else {
		$('.js-accordion dd').slideUp({
			easing: 'easeInOutQuart'
		});
		$accordionContent.slideDown({
			easing: 'easeInOutQuart'
		});
	}
}
